<script lang="ts">
	import AnimatedWaves from "@components/AnimatedWaves.svelte";
	import PodcastCard from "@components/PodcastCard.svelte";
	import Formatted from "@components/common/Formatted.svelte";
	import Layout from "@components/layout/Layout.svelte";
	import type { PodcastProps } from "./PodcastProps.js";

	const { podcasts }: PodcastProps = $props();
</script>

<Layout>
	<section class="mb-12 md:mb-24 lg:mb-40 full-width mt-8 md:mt-16 lg:mt-20">
		<h1 class="w-full huge-heading text-cmcsecondary text-center relative">
			<span class="stroke-text-cmcsecondary text-cmcbg">
				<Formatted text="Poslechněte si" />
			</span>
			<br />
			<span class="absolute full-width inset-y-0 inset-x-0 pointer-events-none">
				<AnimatedWaves />
			</span>
			<span class="relative z-10">
				<Formatted text="náš podcast" />
			</span>
		</h1>
		<p
			class="text-[1.25rem]/[1.2] md:text-xl/[1.2] lg:text-[2rem]/[1.2] font-bold max-w-full sm:max-w-[50rem] lg:max-w-[75rem] text-center text-cmcsecondary px-4 mt-8 mx-auto"
		>
			Pravidelná dávka moudrosti ze skladů do vašich uší.
		</p>
	</section>
	<section class="my-8 md:my-16 lg:my-20 full-width mx-3 xl:mx-8">
		<div class="mx-auto w-full max-w-[100rem]">
			<div
				class="grid gap-1 md:gap-2 justify-center md:grid-cols-2 xl:[grid-template-columns:repeat(auto-fit,minmax(0,528px))]"
			>
				{#each podcasts as podcast (podcast.id)}
					<PodcastCard {podcast} class="w-full max-w-[528px] aspect-square" />
				{/each}
			</div>
		</div>
	</section>
</Layout>
